import { z } from 'zod';

export const upgradeSubscriptionSchema = z.object({
  planCode: z.enum(['PRO', 'BUSINESS']),
});

export type UpgradeSubscriptionInput = z.infer<typeof upgradeSubscriptionSchema>;
